<template>
    <div>        
        <!-- <p class="title">Dashboard</p> -->

        <!-- title and ADD column -->
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">
                    Dashboard
                </p> 
            </div>
            <div class="column">
                <p class="has-text-right">
                  <help-button-component :url="`${domain}media/help/dashboard.pdf`" :as_icon="true"></help-button-component>
                </p>
            </div>
        </div>

        <div class='column is-full'> 
            <div class='card equal-height'>
                <div class='card-content is-flex is-horizontal-center'>
                <figure class='image'>
                    <img src="@/assets/FlowChart_horizontal.png" alt="ValChrom's flowchart">
                </figure>
                </div>
            </div>
        </div>

        <div class="columns">
            <!-- <img src="@/assets/flowchart.jpg" alt="ValChrom's flowchart"> -->
        </div>
    </div>
</template>

<script>
import HelpButtonComponent from '@/components/features/buttons/HelpButtonComponent'
import { mapGetters } from 'vuex'

export default {
    name: 'DashboardComponent',
    components: { HelpButtonComponent },
    computed: {
        ...mapGetters([
            'domain'
        ]),
    }
    
}
</script>

<style scoped>

</style>